"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class IgnoredDevice extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'ignoredDevice';
        this._type = initParams.type;
        this._name = initParams.name;
        this._siteName = initParams.site_name;
    }
    set type(value) {
        console.error('Do not set objects this way');
    }
    get type() {
        return this._type;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    get name() {
        return this._name;
    }
    set siteName(value) {
        console.error('Do not set objects this way');
    }
    get siteName() {
        return this._siteName;
    }
}
exports.default = IgnoredDevice;
//# sourceMappingURL=ignoredDevice.js.map